exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myreport-fulldetail-block {\r\n    font-size: 20px;\r\n    font-family: 'Montserrat';\r\n}\r\n\r\n.myreport-fulldetail-block .btn {\r\n    font-size: 20px;\r\n    padding: 0px;\r\n}\r\n.myreport-fulldetail-block .btn i {\r\n    margin-right: 5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/benchmarks/benchmarks.component.css
// module id = ../../../../../src/app/reports/myReports/benchmarks/benchmarks.component.css
// module chunks = main